const teamPageES = {
	header: {
		title: "Equipo",
		inviteStaff: "Invitar personal",
		manageStaff: "Administrar personal",
	},
	messages: {
		activateFailed: "Error al activar el perfil.",
		noValidEmail: "Ingresa al menos un correo válido.",
		inviteFailed: "No se pudieron enviar algunas invitaciones.",
		removeFailed: "No se pudo eliminar el miembro. Inténtalo de nuevo.",
		removeSuccess: "{{name}} eliminado exitosamente.",
		promoteFailed: "No se pudo promover.",
		demoteFailed: "No se pudo degradar.",
		reinviteFailed: "No se pudo reenviar la invitación.",
	},
	status: {
		active: "Activo",
		registered: "Registrado",
		invited: "Invitado",
		joined: "Registrado",
	},
	main: {
		services: "Servicios",
		noServices: "No hay servicios asignados",
		launch: "Activar",
		active: "Activo",
	inactive: "Inactivo",
	homeService: "A domicilio",
	},
	labels: {
		email: "Correo:",
		phone: "Teléfono:",
		firstName: "Nombre",
		lastName: "Apellido",
		emailAddress: "Correo electrónico",
	},
	actions: {
		addStaff: "+ Agregar personal",
		saveClose: "Guardar y cerrar",
		sending: "Enviando...",
		removing: "Eliminando...",
		cancel: "Cancelar",
		confirm: "Confirmar",
		removing: "Eliminando...",
		promoteToAdmin: "Promover a administrador",
		demoteToStaff: "Degradar a personal",
		reinvite: "Reenviar invitación",
		cancelInvite: "Cancelar invitación",
	},
	confirm: {
		removeStaff: "¿Eliminar a este miembro del equipo?",
		popupTitle: "¿Eliminar a {{name}}?",
		popupSubtitle: "Esta acción no se puede deshacer.",
		cancelInviteTitle: "¿Cancelar la invitación de {{name}}?",
		cancelInviteSubtitle: "La persona ya no podrá unirse.",
		cancel: "Cancelar",
		confirm: "Confirmar",
		warningBookings: "Por favor revise las reservas próximas de este miembro del personal y reasígnelas si es necesario. Si se elimina este miembro del personal, todas las citas activas en su calendario se cancelarán automáticamente. ¿Está seguro de que desea continuar?",
	},
	role: {
		owner: "Propietario",
		admin: "Administrador",
	},

	toast: {
		promotedToAdmin: "{{name}} ahora es administrador.",
		demotedToStaff: "{{name}} fue degradado a personal.",
		inviteResent: "Invitación reenviada.",
		inviteCancelled: "Invitación cancelada para {{name}}",
	},
};
export default teamPageES;
